import type { Feature } from '@luna/gatekeeper';

export const newCardLimitChange: Feature = {
    enabled: false,
    _description: 'Displays card limit change with core solution',
};
